import { useResourceFetchOne } from '@gandi/resource/react';
import { entitiesResource, getFetchParams, createHasPermissions } from '../modules/resources/entities';
export function useEntityPermissions(identifier) {
  const result = useResourceFetchOne(entitiesResource, getFetchParams(identifier));
  const hasPermissions = createHasPermissions(result);
  return {
    hasPermissions,
    isFailurePermissions: result.isFailure,
    isFetchingPermissions: result.isFetching,
    isForbiddenPermissions: result.isForbidden,
    isLoadedPermissions: result.isLoaded,
    isNotFoundPermissions: result.isNotFound,
    shouldFetchPermissions: result.shouldFetch
  };
}
export function preFetchEntityPermissions(args, identifier) {
  const fetchParams = getFetchParams(identifier);
  const label = entitiesResource.computeLabel(entitiesResource.options.fetchOnePath, fetchParams);
  return args.dispatch(entitiesResource.fetchOne(entitiesResource.options.fetchOnePath, {
    label,
    params: fetchParams
  }));
}